import Menu from "./Menu";
import {withRouter} from "react-router";
export default withRouter(Menu);